import React from 'react';
import './Intro.css';
import introImage from '../Assets/images/Profile-1024.png';



const Intro = ({ scrollToArticles }) => {
  return (
    <>
      <div className="intro-container">
        <div className="intro-text">
          <h1 className="intro-title">Hi!</h1>
          <h2 className="intro-subtitle">My name is Felix.</h2>
          <p className="intro-description">
            I am a <strong>UX-Designer</strong>. I love extending my capacity for creation through using new tools and methods, so i coded this webpage as a pet project to collect my UX works.
          </p>
        </div>
        <img src={introImage} alt="Intro" className="intro-image" />
      </div>

      <div className="view-my-work-wrapper" onClick={scrollToArticles}>
  <h2 className="view-my-work">View my work</h2>
  <div className="down-arrow">↓</div>
</div>
    </>
  );
};

export default Intro;
